import {VodViewerDataVo} from '../../common/shared/api/gateway/viewer/VodViewerDataVo.interface';
import {ViewerDataType, VodViewerData} from '../generated/types';
import {createVodDownloadData} from './VodDownloadData';

export function createVodViewerData({
  vod_download_data,
}: VodViewerDataVo): VodViewerData {
  return {
    type: ViewerDataType.VodViewerData,
    vodDownloadData: createVodDownloadData(vod_download_data),
  };
}
